import $ from 'zepto';
import util from './common/util.js';
import './common/login.js';
import main from './common/main.js';
import msgbox from './common/msgbox.js';
import user from './common/user.js';
import template from './common/template.js';
import tj from './common/tj.js';
import share from './tools/share.js';

import packagejson from '../package.json'
let thunderjsversion = packagejson.m;
setCookie('thunderjsversion', thunderjsversion, 24, 1);

$(document).on('click', '.act_prize_list, .act_prize', () => {
    if (!haslogin()) {
        login();
    } else {
        prizelist();
    }
    return false;
}).on('click', '.act_address', () => {
    if (!haslogin()) {
        login();
        return false;
    }
    if (!/ipad/i.test(navigator.userAgent.toLowerCase())) {
        window.open(domainList.act + '/wap/addr.html');
    } else {
        location.href = domainList.act + '/wap/addr.html';
    }
    return false;
});

require('./tools/lottery.js');
var textSlider = require('./tools/textSlider.js');
require('./tools/logistics.js');

var prizelist = function() {
	require.ensure(['./tools/prizelist.js'], function(require) {
        var prizelist = require('./tools/prizelist.js');

        prizelist();
    }, 'prizelist');
}

var pay = require('./tools/vippay_v3.js');
window.thunder = function(fn) {
    $(function() {
        fn.call({
            util: util,
            main: main,
            ajax: util.ajax,
            msgbox: msgbox,
            user: user,
            template: template,
            pay: pay,
            share: share,
            textSlider: textSlider,
            tj: tj
        });
        main.start();
        delete window.thunder;
    })
}



// WEBPACK FOOTER //
// ./src/entry.js